import React from 'react';
import { DesignTokenColor, Heading, HStack, Label } from '@medely/ui-kit';

type Variants = 'primary' | 'secondary';

interface Props {
  oldRate: string;
  newRate: string;
  variant: Variants;
  bold?: boolean;
  color?: DesignTokenColor;
}

interface RateTextProps {
  amount: string;
  variant: Variants;
  strikethrough?: boolean;
  bold?: boolean;
  color?: DesignTokenColor;
}

const RateText = ({ amount, variant, strikethrough, bold, color }: RateTextProps) => {
  if (variant === 'secondary') {
    return (
      <Label size="l" color={color} strikethrough={strikethrough} bold={bold}>
        {amount}
      </Label>
    );
  }

  return (
    <Heading size="xs" color={color} strikethrough={strikethrough} bold={bold}>
      {amount}
    </Heading>
  );
};

export const StrikethroughCurrencyRate = ({
  oldRate,
  newRate,
  variant,
  bold = false,
  color = 'state.success.secondary',
}: Props) => {
  const Arrow = variant === 'secondary' ? Label : Heading;
  const arrowSize = variant === 'secondary' ? 'l' : 'xs';

  return (
    <HStack gap={1} alignItems="center">
      <RateText amount={oldRate} variant={variant} bold={bold} strikethrough color={color} />
      <Arrow bold={bold} size={arrowSize} color={color}>
        →
      </Arrow>
      <RateText amount={newRate} variant={variant} bold={bold} color={color} />
    </HStack>
  );
};
